import { useQuery } from '@tanstack/react-query';

import PromptsService, { uniqueValues } from '@/services/PromptsService';

export const GET_UNIQUE_VALUES_QUERY_KEY = ['unique-values'];

export function useUniqueValues() {
  const { data, isLoading, error, refetch } = useQuery<uniqueValues>({
    queryKey: GET_UNIQUE_VALUES_QUERY_KEY,
    queryFn: () => PromptsService.getUniqueValues(),
  });

  return {
    uniqueValues: data ?? { serviceNames: [], promptNames: [] },
    isLoading,
    error,
    refetch,
  };
}
